function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-9e7ce628"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "sys-wrap"
};
import { useRoute } from "vue-router";
import { reactive, getCurrentInstance, onMounted, ref } from "vue";
export default {
  __name: 'sysPermMgmt',
  setup: function setup(__props) {
    var _useRoute = useRoute(),
      query = _useRoute.query;
    var instance = getCurrentInstance();
    var themeVars = reactive({
      navBarIconColor: "#323232",
      navBarTitleFontSize: "17px"
    });
    var sysInfo = reactive([]);
    var permissionEnum = reactive({
      AudioRecorderPermission: "音频",
      BluetoothPermission: "蓝牙",
      CameraPermission: "相机",
      PhotoAlbumPermission: "相册",
      CoarseLocationPermission: "精准定位",
      LocationPermission: "定位",
      NotificationPermission: "消息通知",
      ReadExternalStoragePermission: "读取外部存储",
      ReadPhoneStatePermission: "读取设备信息",
      WriteExternalStoragePermission: "写入外部存储"
    });

    // ios 没有的权限类型
    var noneIos = reactive(["ReadExternalStoragePermission", "ReadPhoneStatePermission", "WriteExternalStoragePermission"]);
    var nativeAbility = reactive({});
    var getPermissionStatus = function getPermissionStatus(permission) {
      return instance.proxy.$xsyxBridge.checkPermission({
        typeList: permission,
        success: function success(res) {
          console.log("success", res);
        },
        fail: function fail(_fail) {
          console.log("fail", _fail);
        }
      });
    };
    var goBack = function goBack() {
      instance.proxy.$xsyxBridge.popBack();
    };
    var handleGetPermission = function handleGetPermission(item) {
      if (item.isOn) {
        instance.proxy.$xsyxBridge.openSetting();
        return;
      }
      instance.proxy.$xsyxBridge.getPermission({
        type: item.key.replace("Permission", ""),
        isSetting: true,
        success: function success() {
          item.isOn = true;
        }
      });
    };
    var handlePermissionStatus = function handlePermissionStatus(status) {
      var newStatus = {};
      Object.keys(status).forEach(function (k) {
        newStatus["".concat(k, "Permission")] = status[k];
      });
      return newStatus;
    };
    var handlePermissionList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var nativeAbilities, status, b, excludePerm;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              nativeAbilities = Object.keys(nativeAbility);
              status = {};
              _context.prev = 2;
              _context.next = 5;
              return getPermissionStatus(nativeAbilities.map(function (k) {
                return k.replace("Permission", "");
              }));
            case 5:
              status = _context.sent;
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);
              console.log("error", _context.t0);
            case 11:
              status = handlePermissionStatus(status);
              _context.next = 14;
              return instance.proxy.$xsyxBridge.isIos();
            case 14:
              b = _context.sent;
              excludePerm = b ? noneIos : [];
              sysInfo.length = 0;
              nativeAbilities.forEach(function (k) {
                if (!excludePerm.includes(k)) {
                  var isOn = status[k];
                  sysInfo.push({
                    title: permissionEnum[k],
                    label: nativeAbility[k],
                    isOn: isOn,
                    key: k
                  });
                }
              });
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 8]]);
      }));
      return function handlePermissionList() {
        return _ref.apply(this, arguments);
      };
    }();
    var getDeviceInfo = function getDeviceInfo() {
      return new Promise(function (resolve) {
        instance.proxy.$xsyxBridge.getDeviceInfo({
          success: function success(res) {
            resolve(res);
          }
        });
      });
    };
    var navHeight = ref("");
    var setNavHeight = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var b, _yield$getDeviceInfo, statusBarHeight;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return instance.proxy.$xsyxBridge.isAndroid();
            case 2:
              b = _context2.sent;
              if (!b) {
                _context2.next = 9;
                break;
              }
              _context2.next = 6;
              return getDeviceInfo();
            case 6:
              _yield$getDeviceInfo = _context2.sent;
              statusBarHeight = _yield$getDeviceInfo.statusBarHeight;
              navHeight.value = statusBarHeight;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function setNavHeight() {
        return _ref2.apply(this, arguments);
      };
    }();
    setNavHeight();

    // iOS14以下没有精准定位
    var handleIosPermission = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var b, _yield$getDeviceInfo2, systemVersion;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return instance.proxy.$xsyxBridge.isIos();
            case 2:
              b = _context3.sent;
              if (!b) {
                _context3.next = 9;
                break;
              }
              _context3.next = 6;
              return getDeviceInfo();
            case 6:
              _yield$getDeviceInfo2 = _context3.sent;
              systemVersion = _yield$getDeviceInfo2.systemVersion;
              if (systemVersion && Number(systemVersion) < 14) {
                noneIos.push("CoarseLocationPermission");
              }
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function handleIosPermission() {
        return _ref3.apply(this, arguments);
      };
    }();
    var fetchProdData = function fetchProdData() {
      var version = query.version,
        appId = query.appId;
      instance === null || instance === void 0 || instance.proxy.$api.getApplicationInfo({
        version: version,
        appId: appId
      }).then( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(response) {
          var data, code, d, permissionDesc;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                data = response.data, code = response.code;
                if (!(code === 200)) {
                  _context4.next = 15;
                  break;
                }
                _context4.prev = 2;
                d = JSON.parse(data.nativeAbility);
                permissionDesc = d.permissionDesc;
                nativeAbility = permissionDesc || {};
                console.log(nativeAbility);
                _context4.next = 9;
                return handleIosPermission();
              case 9:
                handlePermissionList();
                _context4.next = 15;
                break;
              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](2);
                console.log(_context4.t0);
              case 15:
              case "end":
                return _context4.stop();
            }
          }, _callee4, null, [[2, 12]]);
        }));
        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }());
    };
    var forbidBack = function forbidBack() {
      instance.proxy.$xsyxBridge.shouldBlockPopGesture({
        isBlock: true
      });
    };
    onMounted(function () {
      setTimeout(function () {
        instance.proxy.$vconsole.destroy();
      }, 0);
      forbidBack();
      fetchProdData();
    });
    instance.proxy.$xsyxBridge.webViewWillAppear({
      success: function success() {
        forbidBack();
        fetchProdData();
      }
    });
    instance.proxy.$xsyxBridge.appDidBecomeActive({
      success: function success() {
        fetchProdData();
      }
    });
    return function (_ctx, _cache) {
      var _component_van_nav_bar = _resolveComponent("van-nav-bar");
      var _component_van_icon = _resolveComponent("van-icon");
      var _component_van_cell = _resolveComponent("van-cell");
      var _component_van_cell_group = _resolveComponent("van-cell-group");
      var _component_van_config_provider = _resolveComponent("van-config-provider");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_config_provider, {
        "theme-vars": themeVars
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_nav_bar, {
            onClickLeft: goBack,
            "safe-area-inset-top": "",
            fixed: "",
            "left-arrow": "",
            style: _normalizeStyle({
              'padding-top': navHeight.value + 'px'
            }),
            title: "系统权限设置"
          }, null, 8, ["style"]), _createElementVNode("div", {
            class: "content",
            style: _normalizeStyle({
              'margin-top': 54 + navHeight.value + 'px'
            })
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sysInfo, function (item, index) {
            return _openBlock(), _createBlock(_component_van_cell_group, {
              inset: "",
              key: index
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_van_cell, {
                  title: item.title,
                  label: item.label,
                  "title-class": "custom-cell-title",
                  "value-class": "custom-cell-value",
                  onClick: function onClick($event) {
                    return handleGetPermission(item);
                  }
                }, {
                  value: _withCtx(function () {
                    return [_createElementVNode("span", {
                      style: _normalizeStyle({
                        color: item.isOn ? '#757990 ' : '#07123F'
                      })
                    }, _toDisplayString(item.isOn ? "已开启" : "去设置"), 5), _createVNode(_component_van_icon, {
                      name: "arrow"
                    })];
                  }),
                  _: 2
                }, 1032, ["title", "label", "onClick"])];
              }),
              _: 2
            }, 1024);
          }), 128))], 4)];
        }),
        _: 1
      }, 8, ["theme-vars"])]);
    };
  }
};